'use client'

import { Pagination } from '@/app/src/shared/ui/Pagination'
import { useRouter } from 'next/navigation'

export type IProps = {
  currentPage: number
  lastPage: number
  category?: string | null
  tag?: string | null
  author?: string | null
}

const ArticlesPagination = ({ currentPage, lastPage, category, tag, author }: IProps) => {
  const router = useRouter()
  const typeUrl =
    (category && `categories/${category}`) ||
    (tag && `tags/${tag}`) ||
    (author && `authors/${author}`)

  const handleChange = (page: number) => {
    const partUrl = (typeUrl && `${typeUrl}/${page}`) || `${page}`

    router.push(`/blog/${partUrl}#layout-body`)
  }

  return <Pagination currentPage={currentPage} lastPage={lastPage} onChange={handleChange} />
}

export default ArticlesPagination
